/*
 * Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

import {Directive} from '@angular/core';

@Directive({
  selector: '[ngxPiDsPageLayoutHeader],ngx-pids-page-layout-header',
  host: {
    class: 'ngx-pids-page-layout-header'
  }
})
export class PageLayoutHeaderDirective {

  constructor() {
  }

}

